import { cn } from '@/core/lib/utils/cn'
import { FormInput, Input } from '@/core/ui/forms/input'
import { FormRadioGroup, Radio } from '@/core/ui/forms/radio'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useFormContext } from 'react-hook-form'

const FormPhoneInput = dynamic(
  () => import('@/core/ui/forms/phone-input').then(mod => mod.FormPhoneInput),
  { ssr: false, loading: () => <Input disabled /> },
)

type Props = {
  className?: string
}
export const OtherPassengerDetails: React.FC<Props> = ({ className }) => {
  const t = useTranslations()
  const { control } = useFormContext()
  return (
    <div className={cn('flex flex-col gap-5', className)}>
      <h6 className='font-medium'>{t('trip.passengerDetails')}</h6>
      <div className='flex flex-col gap-3 sm:flex-row'>
        <FormInput
          label={t('forms.passengerNameLabel')}
          labelClassName='text-sm font-medium'
          control={control}
          name='fullName'
          placeholder={t('forms.passengerNamePH')}
          className='w-full'
        />
        <FormInput
          label={t('forms.emailLabel')}
          labelClassName='text-sm font-medium'
          name='email'
          control={control}
          placeholder={t('forms.emailPH')}
          type='email'
          className='w-full'
        />
      </div>
      <div className='flex gap-3'>
        <FormPhoneInput
          label={t('forms.passengerPhoneLabel')}
          labelClassName='text-sm font-medium'
          name='phoneNumber'
          control={control}
          placeholder={t('forms.passengerPhonePH')}
          className='w-full flex-1'
        />
        <div className='hidden flex-1 sm:block'></div>
      </div>
      <FormRadioGroup
        control={control}
        color='danger'
        label={t('forms.passengerRelation')}
        name='relationWithPassenger'
        className='flex flex-col gap-3'
        classNames={{
          label: 'text-sm font-medium',
        }}
      >
        <Radio
          type='radio'
          value='familyOrFriend'
          classNames={{
            label: 'text-grey',
          }}
        >
          {t('forms.family')}
        </Radio>
        <Radio
          type='radio'
          value='travelAgent'
          classNames={{
            label: 'text-grey',
          }}
        >
          {t('forms.agent')}
        </Radio>
        <Radio
          type='radio'
          value='noAnswer'
          classNames={{
            label: 'text-grey',
          }}
        >
          {t('forms.noAns')}
        </Radio>
      </FormRadioGroup>
    </div>
  )
}
